export default __webpack_public_path__ + "static/media/ODEImg7.3f7c9758.PNG";